module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/dr_pepper_590x170-af09c5ed.gif";